import ListViewColumn from '../../../model/list-view-column';

export enum State {
  DEFAULT,
  ORDERBYASC,
  ORDERBYDESC,
}

export type SortEvent = { column: ListViewColumn; state: State };

export class StateChangeEvent {
  constructor(columnId: number, state: State) {
    this.payload = {
      id: columnId,
      state: state,
    };
  }

  public readonly payload: { id: number; state: State };
  get type() {
    return StateChangeEvent.name;
  }
}
